import {Question} from '../../../questions/question/question';
import {User} from '../../../admin/users/user/user';

export class UserQuestion {
  answer: string;
  id: string;
  securityQuestion: Question;
  user: User;
}
